import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[minVal]',
})
export class MinInputValDirective {
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^\d*\d{0,2}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-'];

  @Input('minVal') minVal: number;

  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && parseFloat(next) < this.minVal) {
      event.preventDefault();
    }
  }
}
